import angular from 'angular';

import leadFormModule from '../lead.form/lead.form.module';
import notificationModule from '../ui/notification/notification.module';
import { routesConfig } from './create.new.lead.popup.routes';

import '../settings/appealSources/AppealSourceSelect.directive';
import '../activity/add-note-form.scss';

export default angular
  .module('create.new.lead.popup', [
    leadFormModule.name,
    notificationModule.name,
  ])
  .config(routesConfig);
